import { render, staticRenderFns } from "./krasOnePage.vue?vue&type=template&id=7121ab9b"
import script from "./krasOnePage.vue?vue&type=script&lang=js"
export * from "./krasOnePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7121ab9b')) {
      api.createRecord('7121ab9b', component.options)
    } else {
      api.reload('7121ab9b', component.options)
    }
    module.hot.accept("./krasOnePage.vue?vue&type=template&id=7121ab9b", function () {
      api.rerender('7121ab9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kras/krasOnePage.vue"
export default component.exports